module.exports = __webpack_public_path__ + "static/handelbay_logo_menu-205216067473140660cc6196ddceaa34.png";